var _module_exports ="<span ng-click=\"goToContext()\" class=\"u-pointer\">\n    <span class=\"navCtxt-backTo\">Back to</span>\n    <strong>Search Results</strong>\n</span>";;
var path = '/app/Main/search/GOVHistoryCtxtDirective-searchResults.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;